import {
  Archive,
  ArrowDownToLine,
  ArrowUpToLine,
  BellIcon,
  BookOpenTextIcon,
  BookUserIcon,
  Boxes,
  BriefcaseBusiness,
  Building,
  Building2,
  CalendarDays,
  Car,
  CarFront,
  Coins,
  ConstructionIcon,
  CreditCard,
  DollarSign,
  FileBadge,
  FileBox,
  FileClock,
  FileClockIcon,
  FileSpreadsheet,
  FileStackIcon,
  FileText,
  ForkliftIcon,
  Fuel,
  GlobeLock,
  Group,
  HandshakeIcon,
  KeyRound,
  PieChart,
  PiggyBank,
  Plug,
  PrinterIcon,
  Receipt,
  Repeat2,
  SendHorizonal,
  SquareX,
  Table,
  TableProperties,
  TicketIcon,
  UserRound,
  WalletCards,
  WandSparkles,
  Wrench,
  FileBoxIcon,
  Goal,
  ShoppingBasket,
  Tag,
  UserCog,
  Trophy
} from 'lucide-react'
import { TaurusIcon } from '@/common/components/Icons/TaurusIcon';

const routes = [
  {
    label: 'Dashboard',
    Icon: <PieChart strokeWidth={1} />,
    path: '/',
    permission: 'Admin::Dashboard::Groups::Mine',
  },
  {
    label: 'Relatórios',
    Icon: <FileSpreadsheet strokeWidth={1} />,
    path: '/reports',
    permission: 'Admin::Reports::Entries::PermittedReportsFilter',
  },
  {
    label: 'Negociações',
    Icon: <HandshakeIcon strokeWidth={1} />,
    path: '/negotiations',
    permission: 'Admin::Client::Negotiations::Filter',
  },
  {
    label: 'Impressoras de cartão',
    Icon: <PrinterIcon strokeWidth={1} />,
    path: '/printer-machines',
    permission: 'Admin::Printer::Machines::Filter',
  },
  {
    label: 'POS',
    Icon: <Plug strokeWidth={1} />,
    path: '/pos',
    permission: 'Admin::Pos::Machines::Filter',
  },
  {
    label: 'Cartões',
    Icon: <WalletCards strokeWidth={1} />,
    path: [
      {
        label: 'Cartões pendentes',
        Icon: <CreditCard strokeWidth={1} />,
        path: '/pending-cards',
        permission: 'Admin::Client::Cards::FilterForFabrication',
      },
      {
        label: 'Todos cartões',
        Icon: <WalletCards strokeWidth={1} />,
        path: '/all-cards',
        permission: 'Admin::Client::Cards::Filter',
      },
    ],
  },
  {
    label: 'Regras da operação (CA)',
    Icon: <Wrench strokeWidth={1} />,
    path: [
      {
        label: 'Tarifas',
        Icon: <PiggyBank strokeWidth={1} />,
        path: '/fee-templates',
        permission: 'Admin::Billing::FeeTemplates::Filter',
      },
      {
        label: 'Notificações',
        Icon: <BellIcon strokeWidth={1} />,
        path: '/notifications/configurations',
        permission: 'Admin::NotificationConfigurations::Filter',
      },
      {
        label: 'Envios',
        Icon: <SendHorizonal strokeWidth={1} />,
        path: '/recipient-messages',
        permission: 'Admin::Notifications::RecipientMessages::NotificationsFilter',
      },
      {
        label: 'Tabelas ANP',
        Icon: <Table strokeWidth={1} />,
        path: '/anp-reports',
        permission: 'Admin::Anp::Reports::Filter',
      },
      {
        label: 'Tabelas ANP Mensal',
        Icon: <Table strokeWidth={1} />,
        path: '/anp-historical-reports',
        permission: 'Admin::Anp::HistoricalReports::Filter',
      },
      {
        label: 'Instituições Bancárias',
        Icon: <Building2 strokeWidth={1} />,
        path: '/bank-institutions',
        permission: 'Admin::BankInstitutions::Filter',
      },
      {
        label: 'Produtos',
        Icon: <FileBox strokeWidth={1} />,
        path: '/products',
        permission: 'Admin::Products::Filter',
      },
      {
        label: 'Categorias de Equipamentos',
        Icon: <ForkliftIcon strokeWidth={1} />,
        path: '/equipment-categories',
        permission: 'Admin::EquipmentCategories::Filter',
      },
      {
        label: 'Categorias de Produtos',
        Icon: <Boxes strokeWidth={1} />,
        path: '/product-categories',
        permission: 'Admin::ProductCategories::Filter',
      },
      {
        label: 'Documentos',
        Icon: <FileBadge strokeWidth={1} />,
        path: '/general-documents',
        permission: 'Admin::GeneralDocuments::Filter',
      },
      {
        label: 'Modelos de Equipamentos',
        Icon: <CarFront strokeWidth={1} />,
        path: '/equipment-models',
        permission: 'Admin::EquipmentModels::Filter',
      },
      {
        label: 'Feriados',
        Icon: <CalendarDays strokeWidth={1} />,
        path: '/holidays',
        permission: 'Admin::Calendar::Holidays::Filter',
      },
      {
        label: 'Perfis - Clientes',
        Icon: <WandSparkles strokeWidth={1} />,
        path: '/client-roles',
        permission: 'Admin::Client::Roles::Filter',
      },
      {
        label: 'Perfis - Estabelecimentos',
        Icon: <WandSparkles strokeWidth={1} />,
        path: '/establishment-roles',
        permission: 'Admin::Establishment::Roles::Filter',
      },
      {
        label: 'Permissões - Clientes',
        Icon: <KeyRound strokeWidth={1} />,
        path: '/client-permissions',
        permission: 'Admin::Client::Permissions::Filter',
      },
      {
        label: 'Permissões - Estabelecimentos',
        Icon: <KeyRound strokeWidth={1} />,
        path: '/establishment-permissions',
        permission: 'Admin::Establishment::Permissions::Filter',
      },
    ],
  },
  {
    label: 'Regras da operação (CM)',
    Icon: <Wrench strokeWidth={1} />,
    path: [
      {
        label: 'Documentos Obrigatórios',
        Icon: <BookOpenTextIcon strokeWidth={1} />,
        path: '/establishment-required-documents',
        permission: 'Admin::Maintenance::EstablishmentRequiredDocuments::Filter',
      },
      {
        label: 'Infra. de Rede Credenciada',
        Icon: <ConstructionIcon strokeWidth={1} />,
        path: '/establishment-infrastructures',
        permission: 'Admin::Maintenance::EstablishmentInfrastructures::Filter',
      },
      {
        label: 'Especialidades Técnicas',
        Icon: <BookUserIcon strokeWidth={1} />,
        path: '/establishment-technical-professionals',
        permission: 'Admin::Maintenance::EstablishmentTechnicalProfessionals::Filter',
      },
      {
        label: 'Objetos de manutenção',
        Icon: <FileBoxIcon strokeWidth={1} />,
        path: '/objective-maintenance',
        permission: [
          'Admin::Maintenance::ObjectiveSystems::Filter',
          'Admin::Maintenance::ObjectiveParts::Filter',
          'Admin::Maintenance::ObjectiveActions::Filter',
        ],
      },
    ],
  },
  {
    label: 'Faturas',
    Icon: <FileText strokeWidth={1} />,
    path: [
      {
        label: 'A receber',
        Icon: <ArrowDownToLine strokeWidth={1} />,
        path: '/client-bills',
        permission: 'Admin::Billing::Bills::ClientBillsFilter',
      },
      {
        label: 'A pagar',
        Icon: <ArrowUpToLine strokeWidth={1} />,
        path: '/establishment-bills',
        permission: 'Admin::Billing::Bills::EstablishmentBillsFilter',
      },
      {
        label: 'Arquivo',
        Icon: <Archive strokeWidth={1} />,
        path: '/archive',
        permission: '',
      },
      {
        label: 'Antecipáveis de Fatura',
        Icon: <Archive strokeWidth={1} />,
        path: '/payment-advances',
        permission: 'Admin::Billing::PaymentAdvances::Filter',
      },
    ],
  },
  {
    label: 'Empenhos',
    Icon: <FileStackIcon strokeWidth={1} />,
    path: [
      {
        label: 'Pendentes',
        Icon: <FileClock strokeWidth={1} />,
        path: '/government-allocation-entries/not-completed',
        permission: 'Admin::Billing::GovernmentAllocationEntries::NotCompletedFilter',
      },
      {
        label: 'AF',
        Icon: <FileStackIcon strokeWidth={1} />,
        path: '/supply-authorizations',
        permission: 'Admin::Billing::SupplyAuthorizations::Filter',
      },
    ],
  },
  {
    label: 'Recolha de notas fiscais',
    Icon: <Repeat2 strokeWidth={1} />,
    path: [
      {
        label: 'Por transações',
        Icon: <Coins strokeWidth={1} />,
        path: '/events-with-fiscal-document-requirement',
        permission: 'Admin::Billing::FiscalDocumentGroups::Filter',
      },
      {
        label: 'Por lote',
        Icon: <TableProperties strokeWidth={1} />,
        path: '/billing-fiscal-document-groups',
        permission: 'Admin::Billing::FiscalDocumentGroups::Filter',
      },
    ],
  },
  {
    label: 'Funis',
    Icon: <Car strokeWidth={1} />,
    path: [
      {
        label: 'Clientes privados',
        Icon: <Building strokeWidth={1} />,
        path: '/private-clients',
        permission: 'Admin::Funnel::PrivateCompanyLeads::Filter',
      },
      {
        label: 'Clientes públicos',
        Icon: <GlobeLock strokeWidth={1} />,
        path: '/public-clients',
        permission: 'Admin::Funnel::Public::Leads::Filter',
      },
      {
        label: 'Estabelecimento',
        Icon: <Fuel strokeWidth={1} />,
        path: '/establishment-leads',
        permission: 'Admin::Funnel::Establishment::Leads::Filter',
      },
    ],
    permission: 'Admin::Funnel::PrivateCompanyLeads::Filter',
  },
  {
    label: 'Empresas e filiais',
    Icon: <BriefcaseBusiness strokeWidth={1} />,
    path: '/companies',
    permission: 'Admin::Client::Companies::Filter',
  },
  {
    label: 'Rede credenciada',
    Icon: <Building2 strokeWidth={1} />,
    path: '/establishments',
    permission: 'Admin::Establishment::Companies::Filter',
  },
  {
    label: 'Usuários Tcard',
    Icon: <UserRound strokeWidth={1} />,
    path: [
      {
        label: 'Usuários',
        Icon: <UserRound strokeWidth={1} />,
        path: '/users',
        permission: 'Admin::Users::Filter',
      },
      {
        label: 'Perfis de acesso',
        Icon: <WandSparkles strokeWidth={1} />,
        path: '/tcard-roles',
        permission: 'Admin::Roles::Filter',
      },
      {
        label: 'Permissões',
        Icon: <KeyRound strokeWidth={1} />,
        path: '/permissions',
        permission: 'Admin::Permissions::Filter',
      },
    ],
  },
  {
    label: 'Transações',
    Icon: <DollarSign strokeWidth={1} />,
    path: [
      {
        label: 'Consumo',
        Icon: <Receipt strokeWidth={1} />,
        path: '/consumption',
        permission: 'Admin::Client::Consumptions::Create',
      },
      {
        label: 'Consulta',
        Icon: <WandSparkles strokeWidth={1} />,
        path: '/card-current-limit',
        permission: 'Admin::Client::Cards::CurrentLimits',
      },
      {
        label: 'Estorno',
        Icon: <SquareX strokeWidth={1} />,
        path: '/refund',
        permission: 'Admin::Billing::Refunds::Create',
      },
    ],
  },
  {
    label: 'Grupos',
    Icon: <Group strokeWidth={1} />,
    path: '/groups',
  },
  {
    label: 'Chamados',
    Icon: <TicketIcon strokeWidth={1} />,
    path: [
      {
        label: 'Chamados Externos',
        Icon: <TicketIcon strokeWidth={1} />,
        path: '/external-support',
        permission: 'Admin::Support::Tickets::Filter',
      },
      {
        label: 'Chamados Internos',
        Icon: <TicketIcon strokeWidth={1} />,
        path: '/internal-support',
        permission: 'Admin::Support::Tickets::Filter',
      },
    ],
  },
  {
    label: 'Taurus +',
    Icon: <TaurusIcon strokeWidth={1} />,
    path: [
      {
        label: 'Itens para Resgate',
        Icon: <ShoppingBasket strokeWidth={1} />,
        path: '/tmais-reward-items',
        permission: 'Admin::Tmais::Products::Filter',
      },
      {
        label: 'Destaque para Itens',
        Icon: <Tag strokeWidth={1} />, 
        path: '/tmais-badges',
        permission: 'Admin::Tmais::Badges::Filter', 
      },
      {
        label: 'Missões',
        Icon: <Goal strokeWidth={1} />,
        path: '/tmais-missions',
        permission: 'Admin::Tmais::Missions::Filter',
      },
      {
        label: 'Sorteios',
        Icon: <Trophy strokeWidth={1} />,
        path: '/tmais-raffles',
        permission: 'Admin::Tmais::Raffles::Filter',
      },
      {
        label: 'Clientes T+',
        Icon: <UserCog strokeWidth={1} />,
        path: '/tmais-users',
        permission: 'Admin::Tmais::Users::Filter',
      },
      {
        label: 'Anúncios e Banners',
        Icon: <FileBoxIcon strokeWidth={1} />, 
        path: '/tmais-banners',
        permission: 'Admin::Tmais::Banners::Filter',
      }
    ],
 },
  {
    label: 'Logs',
    Icon: <FileClockIcon strokeWidth={1} />,
    path: '/logs',
    permission: 'Admin::Log::Changes::SystemModelsFilter',
  },
]

const flattenRoutes: any = (items: typeof routes) => items.flatMap((item) => {
  if (Array.isArray(item.path))
    return flattenRoutes(item.path)

  if (typeof item.path === 'string')
    return { ...item }

  return [];
})

export const flattedRoutes: typeof routes = flattenRoutes(routes)

export default routes
